import type {
  PermissionStrategy,
  PermissionType,
  PermissionMetadata,
  PermissionResult,
  PermissionState,
  PlatformContext
} from '../types'

export abstract class BasePermissionStrategy implements PermissionStrategy {
    abstract readonly type: PermissionType
    abstract readonly metadata: PermissionMetadata

    protected context: PlatformContext

    constructor (context: PlatformContext) {
      this.context = context
    }

    abstract check(): Promise<PermissionResult>
    abstract request(): Promise<PermissionResult>
    abstract isSupported(): boolean

    protected createResult (state: PermissionState): PermissionResult {
      return {
        state,
        isGranted: state === 'granted',
        canRequest: state === 'prompt'
      }
    }
}
